import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useRecoilState } from 'recoil';
import { noteModalState } from '../../app/auth/raceKits/state';

/**
 * Read-only view of a highlighted remark, opened from the NOTE badge in the
 * grid. Editing stays in the update form — the desk reads notes far more often
 * than it writes them, and a note read mid-handover should not be editable by
 * accident.
 */
export const NoteModal = () => {
    const [state, setState] = useRecoilState(noteModalState)
    const close = () => setState({ visible: false, raceKit: null })
    const raceKit = state.raceKit

    return (
        <Modal isOpen={state.visible} toggle={close} size="md">
            <ModalHeader toggle={close}>
                Note - {raceKit?.bib_number}
            </ModalHeader>
            <ModalBody>
                {raceKit?.name ? <div className="mb-2 text-muted">{raceKit.name}</div> : null}
                <div className="alert alert-danger mb-0" role="alert" style={{ whiteSpace: 'pre-wrap' }}>
                    <i className="mdi mdi-alert-circle-outline me-1"></i>
                    {raceKit?.remarks}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={close}>Close</Button>
            </ModalFooter>
        </Modal>
    );
};
